import { applyThemeVars } from './lib/apply-theme.js';
import { initWizard } from './wizard.js';
import { initServiceSelector } from './widgets/service-selector.js';
import { initStaffSelector } from './widgets/staff-selector.js';
import { initManageBooking } from './manage-booking.js';

function boot() {
	const cfg = window.BookPressPublic;

	if (!cfg) {
		return;
	}

	applyThemeVars(cfg.theme);

	const bookingRoot = document.getElementById('bookpress-booking-root');
	const serviceRoot = document.getElementById('bookpress-service-selector');
	const staffRoot = document.getElementById('bookpress-staff-selector');
	const manageRoot = document.getElementById('bookpress-manage-booking-root');

	if (bookingRoot) {
		initWizard(bookingRoot, cfg);
	}

	if (serviceRoot) {
		initServiceSelector(serviceRoot, cfg);
	}

	if (staffRoot) {
		initStaffSelector(staffRoot, cfg);
	}

	if (manageRoot) {
		initManageBooking(manageRoot, cfg);
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
